export interface CreditPack {
  id: number;
  name: string;
  credits: number;
  /** Price is ex-VAT — always display as "£X + VAT" in the UI */
  price: number;
  currency: string;
}

export interface CreditBalance {
  balance: number;
  lastUpdated: string;
}

export interface CreditTransaction {
  id: string;
  creditType: string;
  amount: number;
  balanceAfter: number;
  transactionType: string;
  status: string;
  description: string;
  creationTime: string;
}

export interface PurchaseCreditsInput {
  creditPackId: number;
  customerEmail: string;
  successUrl: string;
  cancelUrl: string;
}

export interface PurchaseCreditsResult {
  checkoutUrl: string;
}

export interface BillingPortalInput {
  returnUrl: string;
}

export interface BillingPortalResult {
  portalUrl: string;
}

export class GetCreditTransactionsInput {
  creditType?: string;
  transactionType?: string;
  maxResultCount: number = 10;
  skipCount: number = 0;
}
